import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [auth, setAuth] = useState({
        accessToken: localStorage.getItem('accessToken') || null,
        refreshToken: localStorage.getItem('refreshToken') || null,
        userId: localStorage.getItem('userId') || null,
    });
    const [thirdParyAccount, setThirdParyAccount] = useState('');
    const [apiProvider, setApiProvider] = useState('polygon');
    const [userData, setUserData] = useState(null);
    const [selectedValue, setSelectedValue] = useState('AAPL');
    const [selectedValueAnalysis, setSelectedValueAnalysis] = useState([]);
    const [symbolData, setSymbolData] = useState('AAPL');
    const [baseCurencySymbol, setBaseCurencySymbol] = useState();
    const [curencySymbol, setCurencySymbol] = useState();
    const [openSettings, setOpenSettings] = useState(false);
    const [currentDate, setCurrentDate] = useState('');
    const [currentTime, setCurrentTime] = useState('');
    const [symbolTradeDate, setSymbolTradeDate] = useState(null);
    const handleOpenSettings = () => setOpenSettings(true);
    const handleCloseSettings = () => setOpenSettings(false);
    const [tradeData, setTradeData] = useState([]);
    const [recentTransactionsData, setRecentTransactionsData] = useState([]);
    const settingParams = {}; 
    const integrationsParams = {}; 
    const [accountInfoData, setaccountInfoData] = useState({});
    const [watchlistData, setWatchlistData] = useState();
    const [perfomanceChartData, setPerfomanceChartData] = useState([]);
    const [yourHoldingData, setYourHoldingData] = useState([]);
    const [preferenceData, setPreferenceData] = useState([]);
    const [aioperation, setAiOperation] = useState(1.25);
    const [symbolDetails, setSymbolDetails] = useState([]);
    const [tradingviewsymbol, setTradingviewSymbol] = useState('ZC1!'); 
    const token = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');
    const [selectedNameVariable, setSelectedNameVariable] = useState(null);
    const [availableBalance, setAvailableBalance] = useState();
    const [bidAskData, setBidAskData] = useState();
    const [priceChange, setPriceChange] = useState();
    const [currentPrice, setCurrentPrice] = useState();
    const [highPrice, sethighPrice] = useState();
    const [lowPrice, setlowPrice] = useState();
    const [wasdeData, setWasdeData] = useState(null);
    const [latestWasdeData, setLatestWasdeData] = useState(null);

    const [latestConid, setLatestConid] = useState(null);
    const [olChange, setOlChange] = useState(null);
    const [aiPl, setAiPl] = useState(null);
    const [finalData, setFinalData] = useState([
        { symbol: 'AAPL', full_name: 'AAPL', exchange: 'XNAS', type: 'stocks'}
    ])
    const [watchListLoading, setWatchListLoading] = useState(true);
    const [bidLoading, setBidLoading] = useState(true);
    const [symbolDetailsLoading, setSymbolDetailsLoading] = useState(true);
    const [recentTransLoading, setRecentTransLoading] = useState(true);
    const [allocationPrefLoading, setAllocationPrefLoading] = useState(true);
    const [subdomain, setSubDomain] = useState('');
    const [newsData, setNewsData] = useState('');
    const [newsDataLoading, setNewsDataLoading] = useState(true);
    const [holdingsLoading, setholdingsLoading] = useState(true);
    const [accountLoading, setAccountLoading] = useState(true);
    const [symbol_type, setSymbol_Type] = useState('stocks')
    const [etradeAuthData, setEtradeAuthData] = useState();
    const [etradeAllAccData, setEtradeAllAccData] = useState();
    const [sentimentScore, setSentimentScore] = useState();
    const location = useLocation();

    const login = (accessToken, refreshToken, userId) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('userId', userId);
        setAuth({ accessToken, refreshToken, userId });
        // navigate('/Home/Landing');
    };

    const logout = useCallback(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('subDomain');
        localStorage.removeItem('paidAt');
        localStorage.removeItem('planDuration');
        localStorage.removeItem('expiryAt');
        localStorage.removeItem('paymentType');
        localStorage.removeItem('userName');
        localStorage.clear();
        setAuth({ accessToken: null, refreshToken: null, userId: null });
        navigate('/');
    }, [setAuth, navigate]);

    // useEffect(() => {
    //     if (Array.isArray(wasdeData) && wasdeData.length > 0) {
    //         const latestItem = wasdeData[wasdeData.length - 1];
    //         setLatestWasdeData(latestItem); // Set latest item
            
    //         console.log(latestItem);
            
    //         if (latestItem && latestItem.conid) {
    //             fetchLiveMarketDataWithWasde(latestItem.conid); // Fetch live market data
    //             // getPriceChange(latestItem.conid,null,apiProvider)
    //             getOlChange(latestItem.conid);
    //         }
        // } else {
        //     setLatestWasdeData(null); // Reset if no data
        // }
    // }, [wasdeData]);

    // Function to fetch user data
    const fetchUserData = useCallback(async () => {
        if (userData) return userData; // Use existing data if already fetched
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${auth.userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                },
            });
            setUserData(response.data);
            setSubDomain(response.data.subdomain)
            setThirdParyAccount(response.data?.integrations?.current_integration);
            if (response.data.ai_settings && response.data.ai_settings.ai_operation) {
                setAiOperation(response.data.ai_settings.ai_operation);  // Set ai_operation from userData
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) logout(); // Handle token expiration
        }
    }, [auth.accessToken, auth.userId, logout, userData]);

    const updateUserData = async (key, value) => {
        try {
            const token = localStorage.getItem('accessToken'); // Get the token from localStorage
            const userId = localStorage.getItem('userId');
    
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/user/${userId}`, // API endpoint
                { [key]: value }, // Dynamically set the key-value pair
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
    
            console.log(`${key} updated successfully:`, response.data);
            return response.data; // Return response for further usage
        } catch (error) {
            console.error(`Error updating ${key}:`, error);
            throw error; // Propagate the error for handling
        }
    }

    const account = useCallback(async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/accounts-api`)
                // console.log(response);
                return response.data;
            }
            catch(error){
                console.error("Error fetching user data:", error);
            }
        }
        
    }, [userData]);

    const initEmailChange = async (newemail) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/init-email-change`, 
                { email: newemail },
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error initiating email change:", error); // Updated log message
            // if (error.response?.status === 401) {
            //     logout(); // Handle token expiration
            // }
            return null; // Return null or an error object for consistency
        }
    };

    const changeEmail = async (otp,newemail) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/change-email`, 
                { otp: otp, newEmail: newemail, userId: auth.userId },
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error initiating email change:", error); // Updated log message
            if (error.response?.status === 401) {
                // logout(); // Handle token expiration
            }
            return null; // Return null or an error object for consistency
        }
    };

    const getWatchLists = async (provider, accountId) => {
        setWatchListLoading(true);
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');
        if(domain){
            try {
                // const response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/getWatchLists`);
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/getWatchLists?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/getWatchLists?provider=${provider}&accountId=${accountId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/getWatchLists?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                setWatchlistData(response.data);
            } catch (error) {
                console.error("Error fetching watchlist data:", error);
                setOpenSettings(true); // Open settings in case of an error
            } finally {
                setWatchListLoading(false); // Ensure loading state is updated
            }
        }
    };
    

    const getOrderData = async (provider, accountId) => {
        const domain = localStorage.getItem('subDomain')
        
        setRecentTransLoading(true);
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/orders?provider=${provider}`);
                }
                else if(provider === 'robinhood'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/orders?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/orders?provider=${provider}&accountId=${accountId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/orders?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                setRecentTransactionsData(response.data.orders);
                // console.log(response.data.orders);
                // return response.orders;
                if(response.status === 200){
                    setRecentTransLoading(false);
                }
            }
            catch(error){
                console.error("Error fetching user data:", error);
                // setOpenSettings(true); 
                setRecentTransLoading(false);
            }
        }
    };

    const getRecentTransactions = async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/trades`)
                setTradeData(response.data);
                // console.log(response.data.orders);
                // return response.orders;
            }
            catch(error){
                console.error("Error fetching user data:", error);
                // setOpenSettings(true); 
            }
        }    
    };

    const createOrder = async (quantity, side, ordertype, cashqty, provider, symbol, baseCurencySym, curencySym) => {
        const domain = localStorage.getItem('subDomain')
        let coinAccessToken = localStorage.getItem('coinAccessToken');
        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    const orderData = {
                        orders: [
                            {
                                conid: parseInt(latestConid),
                                orderType: ordertype,
                                side: side,
                                tif: "GTC",
                                manualIndicator: false
                            }
                        ]
                    };
                    if (quantity) {
                        orderData.orders[0].quantity = quantity;
                    }
                    if (cashqty) {
                        orderData.orders[0].cashqty = cashqty;
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/createOrder`,
                        orderData
                    );
                }
                else if(provider === 'robinhood'){
                    const orderData = {
                        side: side,
                        order_type: ordertype,
                        symbol: symbol,
                        order_config: {
                            asset_quantity: quantity
                        }
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/createOrder?provider=${provider}`,
                        orderData
                    );
                }
                else if(provider === 'coinbase'){
                    const orderData = {
                        side: side,
                        symbol: symbol,
                        quantity: quantity,
                        base_currency: baseCurencySym,
                        currency_symbol: curencySym
                    }
                    // console.log(orderData);
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/createOrder?provider=${provider}`,
                        orderData,{
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                return response.data;
            } catch (error) {
                console.error("Error in createOrder:", error);
            }
        }
    };
    
    const addWatchlist = async (provider,baseCurencySym, curencySym, id, name, rows) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/addWatchlist?provider=${provider}`, 
                        { id: id, name: name, rows: rows }
                    );
                } 
                else if(provider === 'etrade'){
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/addWatchlist?provider=${provider}`, 
                        { id: id, name: name, }
                    );
                }
                else if(provider === 'coinbase'){
                    response = await axios.post(
                        `${process.env.REACT_APP_IBKR_API_URL}/addWatchlist?provider=${provider}`, 
                        { base_currency:baseCurencySym, currency_symbol:curencySym, id: id, name: name, }
                    );
                }
                return response.data;
            } catch (error) {
                console.error("Error for addWatchlist:", error);
                
            }
        }
    };

    const deleteWatchlist = async (provider, id) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.delete(
                    `${process.env.REACT_APP_IBKR_API_URL}/deleteWatchlist?provider=${provider}&id=${id}`, 
                );
                // let response;
                // if(provider === 'IBKR'){
                //     response = await axios.delete(
                //         `${process.env.REACT_APP_IBKR_API_URL}/deleteWatchlist?provider=${provider}&id=${id}`, 
                //     );
                // }
                return response.data;
            } catch (error) {
                console.error("Error for addWatchlist:", error);
                
            }
        }
    };

    const aiSettings = async(integrations) => {
        try{
            await axios.put(
                `${process.env.REACT_APP_API_URL}/user/${userId}`, // Replace with your actual API endpoint
                { integrations },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
        }catch (error) {
            console.error("Error for addWatchlist:", error);
        }
    };

    const getSymbolTradeDate = useCallback(async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/getSymbolDetails`, {
                    params: {
                        symbol: selectedNameVariable,
                        secType: "FUT",
                    },
                });
                setSymbolTradeDate(response.data);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        }
    }, [selectedNameVariable]);

    useEffect(() => {
        if (selectedNameVariable) {
            getSymbolTradeDate();
        }
    }, [selectedNameVariable, getSymbolTradeDate]);

    const fetchSymbolDetails = async (symbol) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_IBKR_API_URL}/getSymbolDetails`,
                    {
                        params: {
                            symbol: symbol,
                            secType: "FUT",
                        },
                    }
                );
                return response.data; // Return the API response
            } catch (error) {
                console.error("Error fetching symbol details:", error);
                throw error; // Optionally rethrow the error to handle it in the caller function
            }
        }
    };

    const accountsSummary = async (provider, accountId, instType) => {
        setAccountLoading(true);
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/accountSummary`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/accountSummary?provider=${provider}&accountId=${accountId}&instType=${instType}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/accountSummary?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                setaccountInfoData(response.data);
                if(response.status === 200){
                    setAccountLoading(false);
                }
                // console.log(response.data);
                // return response.orders;
            }
            catch(error){
                console.error("Error fetching user data:", error);
                setAccountLoading(false);
                return null;
                // setOpenSettings(true); 
            }
        }
    };

    const holdingsData = async (provider, accountId) => {
        const domain = localStorage.getItem('subDomain')
        setholdingsLoading(true);
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');

        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/holdings-new`);
                }
                else if(provider === 'robinhood'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/holdings-new?provider=${provider}`);
                }
                else if(provider === 'etrade'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/holdings-new?provider=${provider}&accountId=${accountId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Access-Token': `${xAccessToken}`,
                            'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                        },
                    });
                }
                else if(provider === 'coinbase'){
                    response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/holdings-new?provider=${provider}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${coinAccessToken}`,
                        }
                    });
                }
                setYourHoldingData(response.data.holdings);
                // console.log(response.data);
                // return response.orders;
                if(response.status === 200){
                    setholdingsLoading(false);
                } 
            }
            catch(error){
                console.error("Error fetching user data:", error);
                // setOpenSettings(true); 
                setholdingsLoading(false);
                return null;
            }
        }
    };

    const preformanceData = useCallback(async (provider, accountId, new_interval, startDate, endDate) => {
        const domain = localStorage.getItem('subDomain')
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');
        let coinAccessToken = localStorage.getItem('coinAccessToken');
        if(domain){
            try {
                let response;
                if(provider === 'IBKR'){
                    response =  await axios.post(`${process.env.REACT_APP_IBKR_API_URL}/account-performance-categorized?provider=${provider}`,
                        {params: {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate
                        }
                    });
                }
                else if(provider === 'etrade'){
                    response =  await axios.post(`${process.env.REACT_APP_IBKR_API_URL}/account-performance-categorized?provider=${provider}&accountId=${accountId}`,
                        {params: {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate
                          }
                        },{
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Access-Token': `${xAccessToken}`,
                                'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                            },
                        }
                    );
                }
                else if(provider === 'coinbase'){
                    response =  await axios.post(`${process.env.REACT_APP_IBKR_API_URL}/account-performance-categorized?provider=${provider}`,
                        {params: {
                            interval: new_interval,
                            start_date: startDate,
                            end_date: endDate
                          }
                        },{
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${coinAccessToken}`,
                            }
                        }
                    );
                }
                
                setPerfomanceChartData(response.data)
            }
            catch(error){
                console.error("Error fetching user data:", error);
            }
        }
    }, []);

    useEffect(() => {
        if(userData){
            holdingsData(thirdParyAccount, userData?.integrations?.trade_account_id);
            getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
            getWatchLists(thirdParyAccount, userData?.integrations?.trade_account_id);
            preformanceData(thirdParyAccount, userData?.integrations?.trade_account_id, '1D');
            accountsSummary(thirdParyAccount, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
        }
    },[thirdParyAccount, userData]);

    const allocations = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/allocations`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                },
            });

            setPreferenceData(response.data);

            if (response.status === 200) {
                setAllocationPrefLoading(false);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            setAllocationPrefLoading(false);
            return null;
        }
    }, [auth.accessToken]);

    const editAllocations = async (name, date, position, amount, id) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/allocations/${id}`, 
                {name: name, date:date, position:position, amount:amount},
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            
            if (response.status === 200) {
                // Call the get API to fetch the updated allocations
                await allocations();
            }
            return response;
        } catch (error) {
            console.error("Error fetching user data:", error);
            // if (error.response?.status === 401) logout(); // Handle token expiration
            return null;
        }
    };

    const addAllocations = async (name, date, position, amount) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/allocations`, 
                {name: name, date:date, position:position, amount:amount},
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            if (response.status === 200 || response.status === 201) {
                // Call the get API to fetch the updated allocations
                await allocations(); // Assuming you have a function to get allocations
            }

            return response;
        } catch (error) {
            console.error("Error fetching user data:", error);
            // if (error.response?.status === 401) logout(); // Handle token expiration
            return null;
        }
    };

    const deleteAllocations = async (id) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/allocations/${id}`, 
                {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.accessToken}`,
                }}
            );
            if (response.status === 200 || response.status === 201) {
                // Call the get API to fetch the updated allocations
                await allocations(); // Assuming you have a function to get allocations
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            // if (error.response?.status === 401) logout(); // Handle token expiration
            return null;
        }
    };

    // const trading_historical_data = async (symbol, from, to, schema) => {
    //     if(userData){
    //         try {
    //             const response =  await axios.get(`https://${subdomain}.nodojicommodities.com/custom-apis/get-historical-data`,
    //                 {params: {
    //                     start_time_str : from,
    //                     end_time_str : to,
    //                     schema : schema,
    //                     symbol : symbol
    //                 }
    //             });
    //             return response.data?.historical_data;
    //         }
    //         catch(error){
    //             console.error("Error fetching trading_historical_data data:", error);
    //         }
    //     }
    // };

    const trading_live_data = async (symbol, provider) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
            const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-live-data`, {
                params: {
                schema: 'ohlcv-1s',
                symbol: symbol,
                provider: provider

                },
            });
            if(response.status === 200){
                setSymbolDetailsLoading(false);
            }
            if (response.data && response.data && response.data.live_data.length > 0) {
                if(provider == 'polygon') {
                    setSymbolDetails(response.data.live_data)
                }
                return { data: response.data.live_data };
                
            } else {
                return null;
            }
            } catch (error) {
            console.error("Error fetching live data:", error);
            setSymbolDetailsLoading(false);
            return null;
            }
        }
    };


    const getWasde_data = useCallback(
        async (year = new Date().getFullYear(), cropType = 'corn') => {
          const params = new URLSearchParams();
          if (year) params.append('year', year);
          if (cropType) params.append('cropType', cropType);
    
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL}/wasde-reports?${params.toString()}`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${auth.accessToken}`,
                }
              }
            );
            console.log(response.data);
            
            setWasdeData(response.data); // Update latestWasdeData in AuthContext
            return response.data;
          } catch (error) {
            console.error('Error fetching WASDE data:', error.message);
            return null;
          }
        },
        [auth.accessToken] // Dependencies: stabilize function based on accessToken
    );
    

    const supportEmail = async (title, description) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/support-email`, 
                { 
                    email: 'Taylor@NoDojiCommodities.com',
                    title: title,
                    description: description
                }
            );
            return response.data; // Return the response data on success
        } catch (error) {
            console.error("Error supportEmail:", error); // Updated log message
            return null; // Return null or an error object for consistency
        }
    };
      
    const bid_ask_data = async (symbol, provider) => {
        setBidLoading(true);
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try {
                const response =  await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/latest_bid_ask`,
                    {params: {
                        symbol : symbol,
                        dataset : 'GLBX.MDP3',
                        provider: provider
                    }
                });
                setBidAskData(response.data?.asks_and_bids)
                if(response.status === 200){
                    setBidLoading(false);
                }
            }
            catch(error){
                console.error("Error fetching asks_and_bids data:", error);
                setBidLoading(false);
            }
        }
    };

    const fetchLiveMarketDataWithWasde = async (conid) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
        // console.log('Fetched Conid:', conid);
            try{
                const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-live-market-data?conids_str=${conid}`);
                // console.log("DATA FROM FETCHING CONID:", response.data);
                setSelectedValueAnalysis(response.data);
                return response.data;
            }
            catch(error){
                console.error("Error fetching getLiveMarketData", error);
            }
        }
    }

    const getLiveMarketData = async (symbol) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-live-market-data?conids_str=${symbol}`);
                setSymbolDetails(response.data);
                
                return response.data;
            }
            catch(error){
                console.error("Error fetching getLiveMarketData", error);
                // setSymbolDetailsLoading(false); 
            }
        }
    }

    const getHistoricalMarketData = async (schema,period, apiProvider, symbol, conid, time) => {
        const domain = localStorage.getItem('subDomain')

        if(domain){
            try {
                let params = {

                }
                if(apiProvider == 'IBKR') {
                    params = {
                        conid: conid,
                        bar: schema,
                        period: period,
                    };
                    if (time) {
                        params.startTime = time;
                    }
                } else {

                    let bar, adjustedPeriod, startTime;
                    if (schema.endsWith('d')) {
                        bar = parseInt(schema.replace('d', ''), 10); // Extract the numeric part for days
                        adjustedPeriod = 'day';
                    } else if (schema.endsWith('w')) {
                        bar = parseInt(schema.replace('w', ''), 10); // Extract the numeric part for weeks
                        adjustedPeriod = 'week';
                    } else if (schema.endsWith('m')) {
                        bar = parseInt(schema.replace('m', ''), 10); // Extract the numeric part for months
                        adjustedPeriod = 'month';
                    } else if (schema.endsWith('h')) {
                        bar = parseInt(schema.replace('h', ''), 10); // Extract the numeric part for hours
                        adjustedPeriod = 'hour';
                    } else if (schema.endsWith('min')) {
                        bar = parseInt(schema.replace('min', ''), 10); // Extract the numeric part for minutes
                        adjustedPeriod = 'minute';
                    } else {
                        bar = schema; // Default to the provided schema
                        adjustedPeriod = 'custom'; // Default period
                    }

                    switch (period) {
                        case '1d':
                            startTime = new Date(time);
                            startTime.setDate(startTime.getDate() - 1);

                            // Check if it's Saturday (6) or Sunday (0) and adjust to Friday
                            if (startTime.getDay() === 6) { // Saturday
                                startTime.setDate(startTime.getDate() - 1); // Move to Friday
                            } else if (startTime.getDay() === 0) { // Sunday
                                startTime.setDate(startTime.getDate() - 2); // Move to Friday
                            }
                            break;
                        case '3m':
                            startTime = new Date(time);
                            startTime.setMonth(startTime.getMonth() - 3);
                            break;
                        case '1y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 1);
                            break;
                        case '5y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 5);
                            break;
                        case '6y':
                            startTime = new Date(time);
                            startTime.setFullYear(startTime.getFullYear() - 6);
                            break;
                        default:
                            startTime = new Date(time);
                    }
            
                    // Format startTime
                    startTime = startTime.toISOString().split("T")[0];
                    
                    params = {
                        provider: "polygon",
                        bar: bar,
                        period: adjustedPeriod,
                        startTime: startTime,
                        endTime: time,
                        symbol: symbol
                    };
                    
                }
                
                const response = await axios.get(
                    `${process.env.REACT_APP_IBKR_API_URL}/get-historical-market-data-new`,
                    { params }
                );
                
                return response.data;
            } catch (error) {
                console.error("Error fetching historical-market-data:", error);
            }
        }
    }

    const getPriceChange = async (conid,symbol, provider) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                let response;
                if(provider!= 'IBKR'){
                    response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-price-changes?symbol=${symbol}&provider=${provider}`);
                }
                else{
                    response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-price-changes?conid=${conid}`);
                }
                setPriceChange(response.data.price_changes);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getOlChange = async (conid) => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-last-ol-value?conid=${conid}`);
                setOlChange(response.data?.ol_value);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getAiPl = async () => {
        const domain = localStorage.getItem('subDomain')
        if(domain){
            try{
                const response = await axios.get(`${process.env.REACT_APP_IBKR_API_URL}/get-ai-pl`);
                setAiPl(response.data);
            }
            catch(e){
                console.log("Error getPriceChange :", e);
            }
        }
    }

    const getCropCondition = async (year = 2024, cropcondition = 'Corn Condition', state = '18 Sts') => {
        try {
            const url = `https://newwebapi.nodojicommodities.com/usda-condition-reports?year=${year}&cropType=${cropcondition}&state=${state}`;
            
            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth.accessToken}`,
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching crop condition data:', error.message);
            return null;
        }
    };

    const getCropProgress = async (year = 2024, cropstage = 'Corn Planted', state = '18 States') => {
        try {
            const url = `https://newwebapi.nodojicommodities.com/usda-progress-reports?year=${year}&cropStage=${cropstage}&state=${state}`

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth.accessToken}`,
                }
                
            });
            return response.data;
        }
        catch (error) {
            console.error('Error fetching crop progress data:', error.message);
            return null;
        }
    }
    
    const getAiPnlResults = async(interval) => {
        try{
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pnl-results?date_range=${interval}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${auth.accessToken}`,
                    }
                }
            );
            return response.data;
        }catch(error){
            console.error('Error fetching AiPnl data:', error.message);
            return null;
        }
    }

    const getNews = useCallback(
        async (symbol) => {
          setNewsDataLoading(true);
          try {
            const response = await axios.get(
              `https://ibkrapi.nodojicommodities.com/custom-apis/get-ticker-news?ticker=${symbol}`
            );
      
            if (response.status === 200) {
              // Extract all sentiment values related to the specific symbol
              const filteredSentiments = response.data.results
                .flatMap((article) => article.insights) // Get all insights from articles
                .filter((insight) => insight.ticker === symbol) // Filter by the provided symbol
                .map((insight) => insight.sentiment_reasoning); // Extract only sentiment values
      
                if(filteredSentiments.length === 0){
                    setNewsData(response.data.results);
                }
                else if (filteredSentiments.length > 0) {
                    const sentimentData = await axios.post(
                    `https://sentimentanalysis.nodoji.com/predict`,
                    {
                        texts: filteredSentiments, // Send filtered sentiments as an array
                    },
                    {
                        headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${auth.accessToken}`,
                        },
                    }
                    );
        
                    if (sentimentData.status === 200) {
                        setNewsDataLoading(false);
                        setSentimentScore(sentimentData.data);
                        setNewsData(response.data.results);
                    }
                    else{
                        setNewsDataLoading(true);
                        setNewsData('');
                    }
                }
                
                if (response.data.results.length === 0) {
                    setNewsDataLoading(false);
                }
            }
          } catch (error) {
            console.error("Error fetching AiPnl data:", error.message);
            setNewsDataLoading(false);
            return null;
          }
        },
        [auth.accessToken] // Dependencies: ensure it updates when `auth.accessToken` changes
    );


    const createNewIntegrations = async(name, apikey, secretKey, extraKey) => {
        const token = localStorage.getItem('accessToken'); // Get the token from localStorage
        const userId = localStorage.getItem('userId');

        try{
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/user/${userId}/integrations`, 
                { name: name, api_key: apikey, secret_key:secretKey, extra_key:extraKey},
                { headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }}
            );
            console.log(response);
            
            return response.data;
        }
        catch(error){
            console.error('Error creating new integrations:', error.message);
            return null;
        }
    }

    const eTradeAuth = async(provider) => {
        try{
            const response = await axios.get(`https://ibkrapi.nodojicommodities.com/custom-apis/auth/login?provider=${provider}`);
            // console.log(response.data);
            return response.data;
        }
        catch(error){
            console.log('Failed to get authenticate:',error.message);
            return null;
        }
    }

    const etradeAuthCallback = async(provider, verifier, resourceOwnerKey, resourceOwnerSecret) => {
        try{
            const response = await axios.post(`https://ibkrapi.nodojicommodities.com/custom-apis/auth/callback?provider=${provider}&oauth_verifier=${verifier}&resource_owner_key=${resourceOwnerKey}&resource_owner_secret=${resourceOwnerSecret}`);
            return response.data;
        }
        catch(error){
            console.log('failed etradeAuthCallback:',error.message);
            return null;
        }
    }

    const etradeAllAcc = async() => {
        let xAccessToken = localStorage.getItem('xAccessToken');
        let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

        try{
            const response = await axios.get(`https://ibkrapi.nodojicommodities.com/custom-apis/all-etrade-account`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Access-Token': `${xAccessToken}`,
                    'X-Access-Token-Secret': `${xAccessTokenSecret}`,
                },
            });
            setEtradeAllAccData(response.data);
            console.log(response.data);
        }
        catch(error){
            console.log('failed to get etradeAllAcc:',error.message);
            return null;
        }
    }

    useEffect(() => {
        // Get and format the current date
        const date = new Date();
        const formattedDate = date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        setCurrentDate(formattedDate);

        // Get and format the current time in 24-hour format based on user's timezone
        const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        setCurrentTime(formattedTime);

        if(location.pathname === '/Home/Portfolio'){
            getNews(symbolData);
        }
    }, [userData])

    return (
        <AuthContext.Provider value={{ subdomain, auth, login, logout, fetchUserData, userData,setUserData, updateUserData, initEmailChange, changeEmail, selectedValue, setSelectedValue, currentDate, currentTime, recentTransactionsData, accountInfoData, openSettings, handleOpenSettings, handleCloseSettings, setOpenSettings, watchlistData, yourHoldingData, aioperation, setAiOperation, account, createOrder, addWatchlist, deleteWatchlist, getWatchLists, aiSettings, preformanceData, tradeData, preferenceData, symbolDetails, editAllocations, addAllocations, settingParams, symbolTradeDate, setSelectedNameVariable, getSymbolTradeDate, fetchSymbolDetails, deleteAllocations, perfomanceChartData, trading_live_data, availableBalance, setAvailableBalance, supportEmail, latestWasdeData, getWasde_data, getCropCondition, getCropProgress, getLiveMarketData, getHistoricalMarketData, getPriceChange, priceChange, bid_ask_data, bidAskData, currentPrice, setCurrentPrice, selectedValueAnalysis, setSelectedValueAnalysis, tradingviewsymbol, setTradingviewSymbol ,setLatestConid, finalData, setFinalData, getOrderData, watchListLoading, bidLoading, symbolDetailsLoading, recentTransLoading, allocationPrefLoading, setAllocationPrefLoading, symbolData, setSymbolData, olChange, getOlChange, aiPl, highPrice, sethighPrice, lowPrice, setlowPrice, getAiPnlResults, apiProvider, setApiProvider, getNews, newsData, newsDataLoading, setThirdParyAccount, fetchLiveMarketDataWithWasde, setLatestWasdeData, symbol_type, setSymbol_Type, createNewIntegrations, holdingsLoading, holdingsData, thirdParyAccount, eTradeAuth, setEtradeAuthData, etradeAuthData, etradeAuthCallback, etradeAllAcc, etradeAllAccData, integrationsParams, accountsSummary, sentimentScore, baseCurencySymbol, setBaseCurencySymbol, curencySymbol, setCurencySymbol, setSymbolDetailsLoading}}>
            {children}
        </AuthContext.Provider>
    );
};